import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ canonical, noIndex, description, lang, meta, title, image }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  
  const metaImage = image ? image : "https://kuda.com/opengraph.png"
  const metaTitle= title?? "Kuda | The money App for Africans."
  const metaDescription= description??""
  const schema = {
    "@context": "https://schema.org",
    "@type": "Corporation",
    name: "Kuda",
    description: site.siteMetadata.description,
    url: site.siteMetadata.siteUrl,
    logo: "",
    sameAs: [
      "https://www.instagram.com/joinkuda/",
      "https://www.linkedin.com/company/joinkuda/",
      "https://youtube.com/@joinkuda/",
      "https://www.facebook.com/joinkuda/",
      "https://twitter.com/joinkuda/",
    ],
  }
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      link={
        canonical
          ? [{ rel: 'canonical', key: canonical, href: canonical }]
          : []
      }
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        (noIndex || process.env.GATSBY_ENV !== 'Prod') ? {
          name: `robots`,
          content: `noindex, nofollow`
        } : {},
        {
          name: `image`,
          content: metaImage,
        },
        {
          name: `og:title`,
          content: metaTitle,
        },
        {
          name: `og:description`,
          content: metaDescription,
        },
        {
          itemprop: `name`,
          content: "Kuda | The money App for Africans.",
        },
        {
          itemprop: `description`,
          content: metaDescription,
        },
        {
          itemprop: `image`,
          content: metaImage,
        },
        {
          name: `og:image`,
          content: metaImage,
        },
        {
          name: `og:type`,
          content: `website`,
        },
        {
          name: `og:site_name`,
          content: `kuda Technologies Limited`,
        },
        {
          name: `og:url`,
          content: canonical ? canonical : `https://kuda.com/`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:image:src`,
          content: metaImage,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `facebook-domain-verification`,
          content: `k0exst2gleww8i8liji0p7mu7hyyse`,
        },
      ].concat(meta)}

    >
      {schema && 
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      }
    </Helmet>
  )
}

SEO.defaultProps = {
  description: ``,
  lang: `en`,
  meta: [],
}

SEO.propTypes = {
  canonical: PropTypes.string,
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
}

export default SEO
